import { GenericCollectionFactory } from "../_generics";

export const OrdersStore = GenericCollectionFactory("ORDERS", "uid");